import React from "react";
import ExpenseForm from "./ExpenseForm";
import { connect } from 'react-redux';
import { startAddExpense } from "../actions/expenses";
import { Link } from "react-router-dom"; 

export class AddExpensePage extends React.Component {
    onSubmit = (expense) => {
            this.props.startAddExpense(expense);
            this.props.history.push('/');
    };
    render () {
        return (
            <div> 
                <div className="content-container expense_page add_expense">
                    <div className="page-header">
                        <h1 className="page_name">Add Expense</h1>
                    </div>  
                    <ExpenseForm 
                        onSubmit={this.onSubmit}
                    />
                    <div className="expense_form_button return_home">
                        <Link className="button return_home" to="/dashboard">Return Home</Link>
                    </div>
                </div>                 
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    startAddExpense: (expense) => dispatch(startAddExpense(expense))
});

export default connect(undefined, mapDispatchToProps)(AddExpensePage);


// WEBPACK FOOTER //
// ./src/components/AddExpensePage.js